import { useRef, useMemo, createRef } from 'react';
const useRefs = (arr, dependencies = []) => {
  const refs = useRef([]);
  if (!Array.isArray(arr)) {
    throw new Error(`The useRefs hooks must be given an array, got "${typeof arr}".`);
  }
  refs.current = useMemo(() => arr.map((_, i) => {
    var _refs$current$i;
    return (_refs$current$i = refs.current[i]) !== null && _refs$current$i !== void 0 ? _refs$current$i : /*#__PURE__*/createRef();
  }), dependencies);
  return (refs === null || refs === void 0 ? void 0 : refs.current) || [];
};
export default useRefs;